module.exports = __webpack_public_path__ + "static/media/grandblue.b0e8ff95.jpg";